import _ from 'lodash';
import moment from 'moment';
import api from '@/utils/api';

// 找出指定年份的開帳傳票，去定義開始日期
export async function getYearlyOpenVoucher(year) {
    const resp = await api({
        url: 'AccountingSummaryPage/QueryVouchers',
        method: 'GET',
        params: {
            StartDateStart: moment(`${year}/01/01`, 'YYYY-MM-DD')
                .startOf('year')
                .format('x'),
            StartDateEnd: moment(`${year}/12/31`, 'YYYY-MM-DD')
                .endOf('year')
                .format('x'),
            TransactionType: 12,
        },
    });
    if (resp.data.totalNum) {
        return _.head(resp.data.items)?.dat;
    }
    return null;
}

export async function fetchYearRawData(targetDate) {
    // queryDate 資料截止日期
    const year = moment(targetDate).year();
    const queryDate = +moment(targetDate).year(year).endOf('day').format('x');

    // 找出 StartDate (當年的起始日期)
    // 先找出該年度的開帳傳票，才是當年的起始日期
    let startDate = await getYearlyOpenVoucher(year);
    if (startDate) {
        const OPEN_DATE = moment(+startDate);
        const SELECTED_DATE = moment(+queryDate);

        // 阻擋查詢日期在開帳日期之前
        if (SELECTED_DATE.isBefore(OPEN_DATE)) {
            // this.$message({
            //     showClose: true,
            //     message: `${SELECTED_DATE.year()}年開帳日期為 ${OPEN_DATE.format('YYYY-MM-DD')}，請重新選擇日期範圍。`,
            //     type: 'error',
            // });
            return { startDate, queryDate, rawData: [] };
        }
    } else {
        startDate = +moment(targetDate).year(year).startOf('year').format('x');
    }

    try {
        const { data } = await api({
            url: 'AccountingSummaryReport/QueryBalanceSheet',
            params: { queryDate, startDate },
            method: 'GET',
        });
        return { startDate, queryDate, rawData: data };
    } catch (ex) {
        console.log(ex);
        return { startDate, queryDate, rawData: [] };
    }
}

export function formatCategoryItems(rawData, isShowZeroItems) {
    const items = {
        currentAssets: [],
        nonCurrentAssets: [],
        currentLiabilities: [],
        nonCurrentLiabilities: [],
        totalEquity: [],
    };

    // 資產類貸方科目的金額需 * -1
    items.currentAssets = _.map(rawData.currentAssets, (o) => ({
        ...o,
        ntTotalAmount: o.dC_TYP === 1 ? o.ntTotalAmount : -o.ntTotalAmount,
    }));
    items.nonCurrentAssets = _.map(rawData.nonCurrentAssets, (o) => ({
        ...o,
        ntTotalAmount: o.dC_TYP === 1 ? o.ntTotalAmount : -o.ntTotalAmount,
    }));

    // 負債類借方科目的金額需 * -1
    items.currentLiabilities = _.map(rawData.currentLiabilities, (o) => ({
        ...o,
        ntTotalAmount: o.dC_TYP === 2 ? o.ntTotalAmount : -o.ntTotalAmount,
    }));
    items.nonCurrentLiabilities = _.map(rawData.nonCurrentLiabilities, (o) => ({
        ...o,
        ntTotalAmount: o.dC_TYP === 2 ? o.ntTotalAmount : -o.ntTotalAmount,
    }));
    items.totalEquity = _.map(rawData.totalEquity, (o) => ({
        ...o,
        ntTotalAmount: o.dC_TYP === 2 ? o.ntTotalAmount : -o.ntTotalAmount,
    }));

    // 如果 isShowZeroItems 為 false，則過濾掉金額為 0 的項目
    if (!isShowZeroItems) {
        items.currentAssets = items.currentAssets.filter((item) => item.ntTotalAmount !== 0);
        items.nonCurrentAssets = items.nonCurrentAssets.filter((item) => item.ntTotalAmount !== 0);
        items.currentLiabilities = items.currentLiabilities.filter((item) => item.ntTotalAmount !== 0);
        items.nonCurrentLiabilities = items.nonCurrentLiabilities.filter((item) => item.ntTotalAmount !== 0);
        items.totalEquity = items.totalEquity.filter((item) => item.ntTotalAmount !== 0);
    }
    return items;
}

export function countCategoryTotals(items) {
    const totals = {
        currentAssets: 0,
        nonCurrentAssets: 0,
        currentLiabilities: 0,
        nonCurrentLiabilities: 0,
        totalEquity: 0,
        assets: 0,
        liabilities: 0,
        liabilitiesAndEquity: 0,
    };

    // 計算分類小計
    totals.currentAssets = items.currentAssets.reduce((a, b) => a + b.ntTotalAmount, 0);
    totals.nonCurrentAssets = items.nonCurrentAssets.reduce((a, b) => a + b.ntTotalAmount, 0);
    totals.currentLiabilities = items.currentLiabilities.reduce((a, b) => a + b.ntTotalAmount, 0);
    totals.nonCurrentLiabilities = items.nonCurrentLiabilities.reduce((a, b) => a + b.ntTotalAmount, 0);
    totals.totalEquity = items.totalEquity.reduce((a, b) => a + b.ntTotalAmount, 0);

    // 計算統計
    totals.assets = totals.currentAssets + totals.nonCurrentAssets;
    totals.liabilities = totals.currentLiabilities + totals.nonCurrentLiabilities;
    totals.liabilitiesAndEquity = totals.liabilities + totals.totalEquity;

    return totals;
}
